import 'bootstrap/dist/css/bootstrap.min.css';
import './Styles/App.css';
import React from 'react';
import { useKonami } from 'react-konami-code';
import Socials from './Components/Socials/';
import Header from './Components/Header';
// import Particles from 'react-particles-js';
// import Work from './Components/Work';

const music = new Audio("./smt_comforting.mp3");

const secret = () => {
    console.log('you found the secret!');
    music.play();
};

const App = () => {
    React.useEffect(() => {
        console.log('Konami Secret?');
    }, []);

    useKonami(secret);

    return (
        <div className='App'>
            <Header />
            {/* <Work />
            <Particles /> */}
            <Socials />
        </div>
    );
};

export default App;
